import Link from "next/link";
import styles from "./blogCard.module.scss";
import CallMadeIcon from "@mui/icons-material/CallMade";

const BlogCard = ({ title, blogUrl, featured }) => {
  return (
    <Link href={blogUrl} className={`${styles["blogCardLink"]} `}>
      <>
        <div
          className={`${styles["blogCard"]} ${
            featured === true ? styles["featured"] : ""
          }`}
        >
          <p>{title}</p>
          <div className={`${styles["icon"]}`}>
            <CallMadeIcon />
          </div>
        </div>
      </>
    </Link>
  );
};

export default BlogCard;
